import { createContext } from 'react';
import { ClientSettings } from './interfaces/client-settings';

export const ClientSettingsContext = createContext<ClientSettings>(undefined);
